// @flow
// eslint-disable-next-line import/no-extraneous-dependencies
import { isFunction } from 'lodash';
import type { TFunction } from '@app/components/translation';

import type { Validator } from './index';

type MaxValueValidator = ({
  t: TFunction,
  field: string,
  text?: string,
  limit: number,
}) => Validator;

const disallowedValues = [
  '',
  null,
  'Infinity',
  '-Infinity',
];

const maxValueValidator: MaxValueValidator = ({
  t, field, text, limit,
}) => (value: string) => {
  if (value === undefined) {
    return undefined;
  }

  if (!disallowedValues.includes(value) && !Number.isNaN(Number(value)) && Number(value) <= limit) {
    return undefined;
  }

  if (text) {
    return text;
  }

  if (!t || !isFunction(t)) {
    throw new Error('The translation function (t) is mandatory for creating a validation.');
  }

  return t('{field} is not allowed to be above {limit}', {
    field,
    limit,
    _comment: 'Validation message for max value validator.',
  });
};

export default maxValueValidator;
